(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[606],{

/***/ 51879:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suggested/onboarding",
      function () {
        return __webpack_require__(84860);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _casavo_base_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79713);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88082);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44926);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_CurvedLineDivider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66801);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97275);
/* harmony import */ var _components_Translated__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36510);
/* harmony import */ var _containers_SuggestedProperties__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66693);
/* harmony import */ var _containers_SuggestedProperties_Onboarding_Wizard_steps_styles_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28787);
/* harmony import */ var _context_Cities__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54673);
/* harmony import */ var _design_lib_style_theme_sprinkles_css__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20579);
/* harmony import */ var _design_lib_theme__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(56161);
/* harmony import */ var _shared_styles_styles_css__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29070);
// @ts-ignore

// @ts-ignore













var SuggestedOnboarding = function(param) {
    var areas = param.areas, cities = param.cities;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_context_Cities__WEBPACK_IMPORTED_MODULE_10__/* .CitiesProvider */ .Ft, {
        areas: areas,
        cities: cities,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: t("main-search:MainSearch_SEO_Title")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: "noindex, nofollow",
                        name: "robots"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_6__/* .FullPageLayout */ .u, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_shared_styles_styles_css__WEBPACK_IMPORTED_MODULE_13__/* .backgroundColor.lightBlue */ .Cz.lightBlue, _containers_SuggestedProperties_Onboarding_Wizard_steps_styles_css__WEBPACK_IMPORTED_MODULE_9__/* .suggestedPropertyFlowStepPaddingTop */ .yM),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(_containers_SuggestedProperties_Onboarding_Wizard_steps_styles_css__WEBPACK_IMPORTED_MODULE_9__/* .suggestedPropertyFlowStepContent */ .WR, (0,_design_lib_style_theme_sprinkles_css__WEBPACK_IMPORTED_MODULE_11__/* .sprinkles */ .K)({
                                paddingBottom: {
                                    desktop: "2xl",
                                    mobile: "m"
                                }
                            })),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_casavo_base_ui__WEBPACK_IMPORTED_MODULE_1__/* .Heading2 */ .XJ, {
                                    className: _shared_styles_styles_css__WEBPACK_IMPORTED_MODULE_13__/* .paddingTop.xl */ .od.xl,
                                    children: t("suggested:MainSearch_Intro_Title")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_casavo_base_ui__WEBPACK_IMPORTED_MODULE_1__/* .BodyM */ .iO, {
                                    className: _shared_styles_styles_css__WEBPACK_IMPORTED_MODULE_13__/* .paddingTop.m */ .od.m,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Translated__WEBPACK_IMPORTED_MODULE_7__/* .Translated */ .I, {
                                        i18Key: "suggested:MainSearch_Intro_Description"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CurvedLineDivider__WEBPACK_IMPORTED_MODULE_5__/* .CurvedLineDivider */ .u, {
                        lineSpacingColor: _design_lib_theme__WEBPACK_IMPORTED_MODULE_12__/* .theme.colors.lightBlue */ .r.colors.lightBlue,
                        topColor: "lightBlue"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_SuggestedProperties__WEBPACK_IMPORTED_MODULE_8__/* .CitySelection */ .TI, {})
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (SuggestedOnboarding);
 // @ts-ignore


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5949,8009,7385,8396,3406,9421,6347,4505,8928,3047,7769,2715,2153,5829,7275,5522,2675,9848,6451,9008,1465,2456,6693,9774,2888,179], function() { return __webpack_exec__(51879); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);